import { render, staticRenderFns } from "./discord-pre-flight-check.vue?vue&type=template&id=237ea657&scoped=true&lang=pug&"
import script from "./discord-pre-flight-check.vue?vue&type=script&lang=js&"
export * from "./discord-pre-flight-check.vue?vue&type=script&lang=js&"
import style0 from "./discord-pre-flight-check.vue?vue&type=style&index=0&id=237ea657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ea657",
  null
  
)

export default component.exports